<template>
  <ParticipantDashboardLayout>
    <MatchingProfileForm english />
  </ParticipantDashboardLayout>
</template>

<script>
import MatchingProfileForm from '@/components/aiMatching/MatchingProfileForm.vue';
import ParticipantDashboardLayout from '@/components/shared/ParticipantDashboardLayout.vue';
import { englishOnlyI18nMixin } from '@/mixins';

export default {
  name: 'MatchingProfile',
  components: { MatchingProfileForm, ParticipantDashboardLayout },
  mixins: [englishOnlyI18nMixin]
};
</script>
